import React, { useEffect, useState } from "react";
import "./products.scss";
import CommonBanner from "../../components/CommonBanner/CommonBanner";
import { productsURL } from "../../helpers/paths";
import { productData } from "../../data/product";
import KnowMore from "../../components/KnowMore/KnowMore";
// import PdfForm from "../../components/PdfForm/PdfForm";

const Products = () => {
  // const [show, setShow] = useState(false);

  // const handleClose = () => setShow(false);

  const productList = productData.map((item, i) => (
    <div className="col-md-6 product_col" key={i}>
      <div className="product_box">
        <div className="content_wrapper">
          <h2 className="product_title">{item.title}</h2>
          <img
            width={411}
            height={507}
            src={item.img}
            alt={item.title}
            className={`product_img ${item.class ? item.class : ""}`}
          />
        </div>
        <div className="cta_wrapper">
          {/* {item.linkType === "external" ? ( */}
            <KnowMore
              external={true}
              text={item.ctaText}
              link={item.link}
            />
          {/* ) : (
            <KnowMore
              button={true}
              text="View Product Brochure"
              onclick={() => setShow(true)}
              onclick={() => setShow(true)}
            />
          )} */}
        </div>
      </div>
    </div>
  ));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <CommonBanner link={productsURL} text="Our Products" title="Our Products" />

      <section className="porduct_sec1">
        <div className="my_container">
          <div className="row product_row">{productList}</div>
        </div>
      </section>

      {/* <PdfForm show={show} onHide={handleClose} /> */}
    </>
  );
};

export default Products;
